import $ from 'jquery'
;(function () {
  // Disable form elements on submit

  On.DisableOnSubmit = function () {
    const self = On.DisableOnSubmit

    $(self.formSelector).each((i, form) => {
      if (form.disableOnSubmitIsSet) {
        return
      }
      const $form = $(form)
      $form.on('submit', () => self.onSubmit($form))
      $form.on('ajax:complete', () => self.onComplete($form))
      form.disableOnSubmitIsSet = true
    })
  }

  Object.assign(On.DisableOnSubmit, {
    formSelector: '.js-disable-on-submit',
    ctaSelector: '.js-disable-with-spinner',
    disableAttribute: 'data-disable-with',
    originalAttribute: 'data-original-content',

    onSubmit($form) {
      const formValidator = $form.data('validator')
      if (formValidator && formValidator.numberOfInvalids() > 0) {
        return // Do not disable invalid forms that won't be submitted
      }
      this.getInputs($form).each((i, el) => this.disableElement(el))
    },

    onComplete($form) {
      this.getInputs($form).each((i, el) => this.enableElement(el))
    },

    getInputs($form) {
      return $form.find(`[${this.disableAttribute}], ${this.ctaSelector}`)
    },

    getCtaLoadingClass(element) {
      return element.matches('.u-arrow-link') ? 'u-arrow-link--loading' : 'cta--loading'
    },

    disableElement(el) {
      const $el = $(el)
      $el.prop('disabled', true)

      if ($el.is(this.ctaSelector)) {
        $el[0].classList.add(this.getCtaLoadingClass($el[0]))
      } else {
        if (!$el.attr(this.originalAttribute)) {
          $el.attr(this.originalAttribute, $el.text())
        }
        $el.html($el.attr(this.disableAttribute))
      }
    },

    enableElement(el) {
      const $el = $(el)
      $el.prop('disabled', false)

      if ($el.is(this.ctaSelector)) {
        $el[0].classList.remove(this.getCtaLoadingClass($el[0]))
      } else {
        $el.html($el.attr(`data-${this.originalAttribute}`))
      }
    },
  })

  $(document).ready(On.DisableOnSubmit)
}.call(window))
